// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StarRate_wrapper__Cbtu4"};